import at from '../actionTypes'
import createReducer from './utilities/createReducer'

export default createReducer({}, {
	[at.VOTE_FETCH_SUCCESS]: (state, action) => {
		const userVotes = {}
		action.payload.votes.forEach((vote) => {
			userVotes[vote.featureType] = vote
		})
		return {
			...state,
			userVotes
		}
	}
})



// WEBPACK FOOTER //
// ./src/redux/reducers/voteReducer.js